<template>
    <div id="contact-content" class="container-fluid main-content page-content" v-bind:class="{ respMaincontent: collapseSidebar }">
        <div class="row mb-4 ml-1">
            <div class="col-sm text-left d-flex align-items-center profile-name-bloc">
                <contact-avatar :contact="contact" :profilePicture="profilePicture"></contact-avatar>
                <div class="ml-3">
                    <h3 v-if="contact" class="section-title mb-0">{{ formatPhoneLabel(contact.attributes.name) }}</h3>
                    <p class="mb-0">{{$t('history')}}</p>
                </div>
            </div>
        </div>
        <contact-history
            v-on:hideSidebar = "$emit('hideSidebar')"
            v-on:showSidebar = "$emit('showSidebar')"
            v-on:onChangeFilterBy = "changeFilterBy($event)"
            v-bind:collapseSidebar = "collapseSidebar"
            v-bind:contactInteractions = "contactInteractions"
            v-bind:activePageId = "activePageId"
            v-bind:loading = "loading"
            v-bind:singleContactAllInteractions = "singleContactAllInteractions"
        >
            <template v-slot:sidebar>
                <slot name="sidebar"></slot>
            </template>
        </contact-history>
    </div>
</template>
<script>

// Internal componants
import ContactHistory from './ContactHistory.vue';
import ContactAvatar  from '../../components/contacts/ContactAvatar.vue';

// Import external libraries
import { mapState } from 'vuex';
import { formatPhoneLabel } from '@/libraries/PhoneNumber';

export default {
    components: {
        ContactHistory,
        ContactAvatar
    },
    props: [
        'collapseSidebar',
        'activePageId',
        'contactInteractions',
        'loading',
        'singleContactAllInteractions'
    ],

    data () {
        return {
            profilePicture: null,
            contactName:    null
        };
    },

    computed: {
        ...mapState('core/contacts', {
            contact: 'single'
        })
    },

    methods: {
        formatPhoneLabel
    },

    watch: {
        contact () {
            // If user have a profile picture
            if (this.contact !== null && this.contact.attributes['profile-picture'] !== '' && this.contact.attributes['profile-picture'] !== null) {
                this.profilePicture = this.contact.attributes['profile-picture'];
            } else {
                this.profilePicture = null;
            }
        }
    }
};
</script>
